module.exports = __webpack_public_path__ + "fonts/e514e4f.woff";